import { createContext } from "react"
export const CollapseContext = createContext({ collapse() {} })

export const ListContext = createContext<{
    optionsFunc?: string
    showIndex: boolean
} | null>(null)
